import { get, post, del, put } from '@api/request';
import { defaultPageSize } from '@constants';

export async function fetchSearchOptions(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/pagesearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchWebpages(
  { appraisalService },
  authenticationToken,
  {
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    searchOptions,
  },
) {
  let url = `${appraisalService}/appraisal/pages`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  if (
    searchOptions &&
    searchOptions.pagePropertyTypes &&
    searchOptions.pagePropertyTypes.length > 0
  ) {
    searchOptions.pagePropertyTypes.forEach(option => {
      url += `&pagePropertyTypes[]=${option}`;
    });
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

// export async function searchWebpage ({appraisalService}, authenticationToken, { pageSize = defaultPageSize, page = 1, sortField, sortDirection, filterModel, searchOptions }) {
//   let url = `${appraisalService}/appraisal/page/search`;
//   url += `?page=${page}&pageSize=${pageSize}`;
//   if (sortField && sortDirection) {
//     url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
//   }
//   if (filterModel && Object.keys(filterModel).length >= 0) {
//     Object.keys(filterModel).forEach((filter) => {
//       url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
//     });
//   }
//   const { body } = await post(authenticationToken, url, searchOptions);
//   return body;
// }

// export async function fetchFields ({appraisalService}, authenticationToken) {
//   const url = `${appraisalService}/appraisal/config/pagesearchresults`;
//   const { body } = await get(authenticationToken, url);
//   return body;
// }

export async function fetchTags({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/page/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchWebpage(
  { appraisalService },
  authenticationToken,
  { webpageId },
) {
  const url = `${appraisalService}/appraisal/page/${webpageId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchWebpageNotes(
  { appraisalService },
  authenticationToken,
  { webpageId },
) {
  const url = `${appraisalService}/appraisal/page/${webpageId}/notes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteWebpageNote(
  { appraisalService },
  authenticationToken,
  { noteId },
) {
  const url = `${appraisalService}/appraisal/pagenote/${noteId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateWebpageNote(
  { appraisalService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${appraisalService}/appraisal/pagenote/${noteId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function addWebpageNote(
  { appraisalService },
  authenticationToken,
  { webpageId, data },
) {
  const url = `${appraisalService}/appraisal/page/${webpageId}/notes`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function validateWebpage(
  { appraisalService },
  authenticationToken,
  { webpageId, data },
) {
  const url = `${appraisalService}/appraisal/page/${webpageId}/casscertification`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updateWebpage(
  { appraisalService },
  authenticationToken,
  { webpageId, data },
) {
  const url = `${appraisalService}/appraisal/page/${webpageId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function createWebpage(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/pages`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function deleteWebpage(
  { appraisalService },
  authenticationToken,
  { webpageId },
) {
  const url = `${appraisalService}/appraisal/page/${webpageId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function duplicateWebpage(
  { appraisalService },
  authenticationToken,
  { webpageId },
) {
  const url = `${appraisalService}/appraisal/page/${webpageId}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}
